/*! For license information please see georaster-layer-for-leaflet.min.js.LICENSE.txt */ ! function(t, e) {
    "object" == typeof exports && "object" == typeof module ? module.exports = e(require("leaflet")) : "function" == typeof define && define.amd ? define(["leaflet"], e) : "object" == typeof exports ? exports.GeoRasterLayer = e(require("leaflet")) : t.GeoRasterLayer = e(t.L)
}(self, (function(t) {
    return (() => {
        var e = {
                771: function(t, e, r) {
                    var n;
                    t = r.nmd(t),
                        function() {
                            var r, o, a, i, u, f, c, s, l, h, d, p, b, g, v, y, m, w, x, _, k, j, M, L, N, S, O, P, E, T, A, R, G, B, C, F, z, W, V, I, q, Y, U, X, D, H, Z, $, K, J, Q, tt, et, rt, nt, ot, at, it, ut, ft, ct, st, lt, ht, dt, pt, bt, gt, vt, yt, mt, wt, xt, _t, kt, jt, Mt, Lt, Nt, St, Ot = [].slice;
                            jt = function() {
                                    var t, e, r, n, o;
                                    for (t = {}, n = 0, e = (o = "Boolean Number String Function Array Date RegExp Undefined Null".split(" ")).length; n < e; n++) r = o[n], t["[object " + r + "]"] = r.toLowerCase();
                                    return function(e) {
                                        var r;
                                        return r = Object.prototype.toString.call(e), t[r] || "object"
                                    }
                                }(), Z = function(t, e, r) {
                                    return null == e && (e = 0), null == r && (r = 1), t < e && (t = e), t > r && (t = r), t
                                }, Mt = function(t) {
                                    return t.length >= 3 ? Array.prototype.slice.call(t) : t[0]
                                }, k = function(t) {
                                    var e, r;
                                    for (t._clipped = !1, t._unclipped = t.slice(0), e = r = 0; r < 3; e = ++r) e < 3 ? ((t[e] < 0 || t[e] > 255) && (t._clipped = !0), t[e] < 0 && (t[e] = 0), t[e] > 255 && (t[e] = 255)) : 3 === e && (t[e] < 0 && (t[e] = 0), t[e] > 1 && (t[e] = 1));
                                    return t._clipped || delete t._unclipped, t
                                }, i = Math.PI, mt = Math.round, M = Math.cos, P = Math.floor, nt = Math.pow, $ = Math.log, xt = Math.sin, _t = Math.sqrt, g = Math.atan2, Q = Math.max, b = Math.abs, c = 2 * i, u = i / 3, o = i / 180, f = 180 / i, (_ = function() {
                                    return arguments[0] instanceof r ? arguments[0] : function(t, e, r) {
                                        r.prototype = t.prototype;
                                        var n = new r,
                                            o = t.apply(n, e);
                                        return Object(o) === o ? o : n
                                    }(r, arguments, (function() {}))
                                }).default = _, p = [], null !== t && null != t.exports && (t.exports = _), void 0 === (n = function() {
                                    return _
                                }.apply(e, [])) || (t.exports = n), _.version = "1.4.1", d = {}, l = [], h = !1, r = function() {
                                    function t() {
                                        var t, e, r, n, o, a, i, u, f;
                                        for (a = this, e = [], u = 0, n = arguments.length; u < n; u++) null != (t = arguments[u]) && e.push(t);
                                        if (e.length > 1 && (i = e[e.length - 1]), null != d[i]) a._rgb = k(d[i](Mt(e.slice(0, -1))));
                                        else {
                                            for (h || (l = l.sort((function(t, e) {
                                                    return e.p - t.p
                                                })), h = !0), f = 0, o = l.length; f < o && !(i = (r = l[f]).test.apply(r, e)); f++);
                                            i && (a._rgb = k(d[i].apply(d, e)))
                                        }
                                        null == a._rgb && console.warn("unknown format: " + e), null == a._rgb && (a._rgb = [0, 0, 0]), 3 === a._rgb.length && a._rgb.push(1)
                                    }
                                    return t.prototype.toString = function() {
                                        return this.hex()
                                    }, t
                                }(), _._input = d, _.brewer = w = {
                                    OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"],
                                    PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"],
                                    BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"],
                                    Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"],
                                    BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"],
                                    YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"],
                                    YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"],
                                    Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"],
                                    RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"],
                                    Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"],
                                    YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"],
                                    Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"],
                                    GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"],
                                    Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#212121000"],
                                    YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"],
                                    PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"],
                                    Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"],
                                    PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"],
                                    Viridis: ["#440154", "#482777", "#3f4a8a", "#31678e", "#26838f", "#1f9d8a", "#6cce5a", "#b6de2b", "#fee825"],
                                    Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"],
                                    RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"],
                                    RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"],
                                    PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"],
                                    PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"],
                                    RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
                                    BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"],
                                    RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"],
                                    PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"],
                                    Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"],
                                    Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"],
                                    Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"],
                                    Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"],
                                    Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"],
                                    Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"],
                                    Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"],
                                    Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"]
                                },
                                function() {
                                    var t, e;
                                    for (t in e = [], w) e.push(w[t.toLowerCase()] = w[t])
                                }(), _.colors = Lt = {
                                    aliceblue: "#f0f8ff",
                                    antiquewhite: "#faebd7",
                                    aqua: "#00ffff",
                                    aquamarine: "#7fffd4",
                                    azure: "#f0ffff",
                                    beige: "#f5f5dc",
                                    bisque: "#ffe4c4",
                                    black: "#212121000",
                                    blanchedalmond: "#ffebcd",
                                    blue: "#2121210ff",
                                    blueviolet: "#8a2be2",
                                    brown: "#a52a2a",
                                    burlywood: "#deb887",
                                    cadetblue: "#5f9ea0",
                                    chartreuse: "#7fff00",
                                    chocolate: "#d2691e",
                                    coral: "#ff7f50",
                                    cornflower: "#6495ed",
                                    cornflowerblue: "#6495ed",
                                    cornsilk: "#fff8dc",
                                    crimson: "#dc143c",
                                    cyan: "#00ffff",
                                    darkblue: "#21212108b",
                                    darkcyan: "#008b8b",
                                    darkgoldenrod: "#b8860b",
                                    darkgray: "#a9a9a9",
                                    darkgreen: "#006400",
                                    darkgrey: "#a9a9a9",
                                    darkkhaki: "#bdb76b",
                                    darkmagenta: "#8b008b",
                                    darkolivegreen: "#556b2f",
                                    darkorange: "#ff8c00",
                                    darkorchid: "#9932cc",
                                    darkred: "#8b0000",
                                    darksalmon: "#e9967a",
                                    darkseagreen: "#8fbc8f",
                                    darkslateblue: "#483d8b",
                                    darkslategray: "#2f4f4f",
                                    darkslategrey: "#2f4f4f",
                                    darkturquoise: "#00ced1",
                                    darkviolet: "#9400d3",
                                    deeppink: "#ff1493",
                                    deepskyblue: "#00bfff",
                                    dimgray: "#696969",
                                    dimgrey: "#696969",
                                    dodgerblue: "#1e90ff",
                                    firebrick: "#b22222",
                                    floralwhite: "#fffaf0",
                                    forestgreen: "#228b22",
                                    fuchsia: "#ff00ff",
                                    gainsboro: "#dcdcdc",
                                    ghostwhite: "#f8f8ff",
                                    gold: "#ffd700",
                                    goldenrod: "#daa520",
                                    gray: "#808080",
                                    green: "#008000",
                                    greenyellow: "#adff2f",
                                    grey: "#808080",
                                    honeydew: "#f0fff0",
                                    hotpink: "#ff69b4",
                                    indianred: "#cd5c5c",
                                    indigo: "#4b0082",
                                    ivory: "#fffff0",
                                    khaki: "#f0e68c",
                                    laserlemon: "#ffff54",
                                    lavender: "#e6e6fa",
                                    lavenderblush: "#fff0f5",
                                    lawngreen: "#7cfc00",
                                    lemonchiffon: "#fffacd",
                                    lightblue: "#add8e6",
                                    lightcoral: "#f08080",
                                    lightcyan: "#e0ffff",
                                    lightgoldenrod: "#fafad2",
                                    lightgoldenrodyellow: "#fafad2",
                                    lightgray: "#d3d3d3",
                                    lightgreen: "#90ee90",
                                    lightgrey: "#d3d3d3",
                                    lightpink: "#ffb6c1",
                                    lightsalmon: "#ffa07a",
                                    lightseagreen: "#20b2aa",
                                    lightskyblue: "#87cefa",
                                    lightslategray: "#778899",
                                    lightslategrey: "#778899",
                                    lightsteelblue: "#b0c4de",
                                    lightyellow: "#ffffe0",
                                    lime: "#00ff00",
                                    limegreen: "#32cd32",
                                    linen: "#faf0e6",
                                    magenta: "#ff00ff",
                                    maroon: "#800000",
                                    maroon2: "#7f0000",
                                    maroon3: "#b03060",
                                    mediumaquamarine: "#66cdaa",
                                    mediumblue: "#2121210cd",
                                    mediumorchid: "#ba55d3",
                                    mediumpurple: "#9370db",
                                    mediumseagreen: "#3cb371",
                                    mediumslateblue: "#7b68ee",
                                    mediumspringgreen: "#00fa9a",
                                    mediumturquoise: "#48d1cc",
                                    mediumvioletred: "#c71585",
                                    midnightblue: "#191970",
                                    mintcream: "#f5fffa",
                                    mistyrose: "#ffe4e1",
                                    moccasin: "#ffe4b5",
                                    navajowhite: "#ffdead",
                                    navy: "#212121080",
                                    oldlace: "#fdf5e6",
                                    olive: "#808000",
                                    olivedrab: "#6b8e23",
                                    orange: "#ffa500",
                                    orangered: "#ff4500",
                                    orchid: "#da70d6",
                                    palegoldenrod: "#eee8aa",
                                    palegreen: "#98fb98",
                                    paleturquoise: "#afeeee",
                                    palevioletred: "#db7093",
                                    papayawhip: "#ffefd5",
                                    peachpuff: "#ffdab9",
                                    peru: "#cd853f",
                                    pink: "#ffc0cb",
                                    plum: "#dda0dd",
                                    powderblue: "#b0e0e6",
                                    purple: "#800080",
                                    purple2: "#7f007f",
                                    purple3: "#a020f0",
                                    rebeccapurple: "#663399",
                                    red: "#ff0000",
                                    rosybrown: "#bc8f8f",
                                    royalblue: "#4169e1",
                                    saddlebrown: "#8b4513",
                                    salmon: "#fa8072",
                                    sandybrown: "#f4a460",
                                    seagreen: "#2e8b57",
                                    seashell: "#fff5ee",
                                    sienna: "#a0522d",
                                    silver: "#c0c0c0",
                                    skyblue: "#87ceeb",
                                    slateblue: "#6a5acd",
                                    slategray: "#708090",
                                    slategrey: "#708090",
                                    snow: "#fffafa",
                                    springgreen: "#00ff7f",
                                    steelblue: "#4682b4",
                                    tan: "#d2b48c",
                                    teal: "#008080",
                                    thistle: "#d8bfd8",
                                    tomato: "#ff6347",
                                    turquoise: "#40e0d0",
                                    violet: "#ee82ee",
                                    wheat: "#f5deb3",
                                    white: "#ffffff",
                                    whitesmoke: "#f5f5f5",
                                    yellow: "#ffff00",
                                    yellowgreen: "#9acd32"
                                }, Y = function() {
                                    var t, e, r, n, o, i, u;
                                    return n = (e = Mt(arguments))[0], t = e[1], r = e[2], i = (n + 16) / 116, o = isNaN(t) ? i : i + t / 500, u = isNaN(r) ? i : i - r / 200, i = a.Yn * U(i), o = a.Xn * U(o), u = a.Zn * U(u), [St(3.2404542 * o - 1.5371385 * i - .4985314 * u), St(-.969266 * o + 1.8760108 * i + .041556 * u), r = St(.0556434 * o - .2040259 * i + 1.0572252 * u), e.length > 3 ? e[3] : 1]
                                }, St = function(t) {
                                    return 255 * (t <= .00304 ? 12.92 * t : 1.055 * nt(t, 1 / 2.4) - .055)
                                }, U = function(t) {
                                    return t > a.t1 ? t * t * t : a.t2 * (t - a.t0)
                                }, a = {
                                    Kn: 18,
                                    Xn: .95047,
                                    Yn: 1,
                                    Zn: 1.08883,
                                    t0: .137931034,
                                    t1: .206896552,
                                    t2: .12841855,
                                    t3: .008856452
                                }, lt = function() {
                                    var t, e, r, n, o, a, i;
                                    return r = (n = Mt(arguments))[0], e = n[1], t = n[2], a = (o = gt(r, e, t))[0], [116 * (i = o[1]) - 16, 500 * (a - i), 200 * (i - o[2])]
                                }, vt = function(t) {
                                    return (t /= 255) <= .04045 ? t / 12.92 : nt((t + .055) / 1.055, 2.4)
                                }, Nt = function(t) {
                                    return t > a.t3 ? nt(t, 1 / 3) : t / a.t2 + a.t0
                                }, gt = function() {
                                    var t, e, r, n;
                                    return r = (n = Mt(arguments))[0], e = n[1], t = n[2], r = vt(r), e = vt(e), t = vt(t), [Nt((.4124564 * r + .3575761 * e + .1804375 * t) / a.Xn), Nt((.2126729 * r + .7151522 * e + .072175 * t) / a.Yn), Nt((.0193339 * r + .119192 * e + .9503041 * t) / a.Zn)]
                                }, _.lab = function() {
                                    return function(t, e, r) {
                                        r.prototype = t.prototype;
                                        var n = new r,
                                            o = t.apply(n, e);
                                        return Object(o) === o ? o : n
                                    }(r, Ot.call(arguments).concat(["lab"]), (function() {}))
                                }, d.lab = Y, r.prototype.lab = function() {
                                    return lt(this._rgb)
                                }, v = function(t) {
                                    var e, r, n, o, a, i, u, f, c, s, l;
                                    return 2 === (t = function() {
                                        var e, r, n;
                                        for (n = [], r = 0, e = t.length; r < e; r++) o = t[r], n.push(_(o));
                                        return n
                                    }()).length ? (c = function() {
                                        var e, r, n;
                                        for (n = [], r = 0, e = t.length; r < e; r++) o = t[r], n.push(o.lab());
                                        return n
                                    }(), a = c[0], i = c[1], e = function(t) {
                                        var e, r;
                                        return r = function() {
                                            var r, n;
                                            for (n = [], e = r = 0; r <= 2; e = ++r) n.push(a[e] + t * (i[e] - a[e]));
                                            return n
                                        }(), _.lab.apply(_, r)
                                    }) : 3 === t.length ? (s = function() {
                                        var e, r, n;
                                        for (n = [], r = 0, e = t.length; r < e; r++) o = t[r], n.push(o.lab());
                                        return n
                                    }(), a = s[0], i = s[1], u = s[2], e = function(t) {
                                        var e, r;
                                        return r = function() {
                                            var r, n;
                                            for (n = [], e = r = 0; r <= 2; e = ++r) n.push((1 - t) * (1 - t) * a[e] + 2 * (1 - t) * t * i[e] + t * t * u[e]);
                                            return n
                                        }(), _.lab.apply(_, r)
                                    }) : 4 === t.length ? (l = function() {
                                        var e, r, n;
                                        for (n = [], r = 0, e = t.length; r < e; r++) o = t[r], n.push(o.lab());
                                        return n
                                    }(), a = l[0], i = l[1], u = l[2], f = l[3], e = function(t) {
                                        var e, r;
                                        return r = function() {
                                            var r, n;
                                            for (n = [], e = r = 0; r <= 2; e = ++r) n.push((1 - t) * (1 - t) * (1 - t) * a[e] + 3 * (1 - t) * (1 - t) * t * i[e] + 3 * (1 - t) * t * t * u[e] + t * t * t * f[e]);
                                            return n
                                        }(), _.lab.apply(_, r)
                                    }) : 5 === t.length && (r = v(t.slice(0, 3)), n = v(t.slice(2, 5)), e = function(t) {
                                        return t < .5 ? r(2 * t) : n(2 * (t - .5))
                                    }), e
                                }, _.bezier = function(t) {
                                    var e;
                                    return (e = v(t)).scale = function() {
                                        return _.scale(e)
                                    }, e
                                }, _.cubehelix = function(t, e, r, n, o) {
                                    var a, i, u;
                                    return null == t && (t = 300), null == e && (e = -1.5), null == r && (r = 1), null == n && (n = 1), null == o && (o = [0, 1]), a = 0, "array" === jt(o) ? i = o[1] - o[0] : (i = 0, o = [o, o]), (u = function(u) {
                                        var f, s, l, h, d;
                                        return f = c * ((t + 120) / 360 + e * u), h = nt(o[0] + i * u, n), s = (0 !== a ? r[0] + u * a : r) * h * (1 - h) / 2, l = M(f), d = xt(f), _(k([255 * (h + s * (-.14861 * l + 1.78277 * d)), 255 * (h + s * (-.29227 * l - .90649 * d)), 255 * (h + s * (1.97294 * l)), 1]))
                                    }).start = function(e) {
                                        return null == e ? t : (t = e, u)
                                    }, u.rotations = function(t) {
                                        return null == t ? e : (e = t, u)
                                    }, u.gamma = function(t) {
                                        return null == t ? n : (n = t, u)
                                    }, u.hue = function(t) {
                                        return null == t ? r : ("array" === jt(r = t) ? 0 == (a = r[1] - r[0]) && (r = r[1]) : a = 0, u)
                                    }, u.lightness = function(t) {
                                        return null == t ? o : ("array" === jt(t) ? (o = t, i = t[1] - t[0]) : (o = [t, t], i = 0), u)
                                    }, u.scale = function() {
                                        return _.scale(u)
                                    }, u.hue(r), u
                                }, _.random = function() {
                                    var t, e;
                                    for (t = "#", e = 0; e < 6; ++e) t += "0123456789abcdef".charAt(P(16 * Math.random()));
                                    return new r(t)
                                }, p = [], C = function(t, e, r, n) {
                                    var o, a, i, u;
                                    for (null == r && (r = .5), null == n && (n = "rgb"), "object" !== jt(t) && (t = _(t)), "object" !== jt(e) && (e = _(e)), i = 0, a = p.length; i < a; i++)
                                        if (n === (o = p[i])[0]) {
                                            u = o[1](t, e, r, n);
                                            break
                                        } if (null == u) throw "color mode " + n + " is not supported";
                                    return u.alpha(t.alpha() + r * (e.alpha() - t.alpha()))
                                }, _.interpolate = C, r.prototype.interpolate = function(t, e, r) {
                                    return C(this, t, e, r)
                                }, _.mix = C, r.prototype.mix = r.prototype.interpolate, d.rgb = function() {
                                    var t, e, r, n;
                                    for (t in r = [], e = Mt(arguments)) n = e[t], r.push(n);
                                    return r
                                }, _.rgb = function() {
                                    return function(t, e, r) {
                                        r.prototype = t.prototype;
                                        var n = new r,
                                            o = t.apply(n, e);
                                        return Object(o) === o ? o : n
                                    }(r, Ot.call(arguments).concat(["rgb"]), (function() {}))
                                }, r.prototype.rgb = function(t) {
                                    return null == t && (t = !0), t ? this._rgb.map(Math.round).slice(0, 3) : this._rgb.slice(0, 3)
                                }, r.prototype.rgba = function(t) {
                                    return null == t && (t = !0), t ? [Math.round(this._rgb[0]), Math.round(this._rgb[1]), Math.round(this._rgb[2]), this._rgb[3]] : this._rgb.slice(0)
                                }, l.push({
                                    p: 3,
                                    test: function(t) {
                                        var e;
                                        return e = Mt(arguments), "array" === jt(e) && 3 === e.length || 4 === e.length && "number" === jt(e[3]) && e[3] >= 0 && e[3] <= 1 ? "rgb" : void 0
                                    }
                                }), d.lrgb = d.rgb, W = function(t, e, n, o) {
                                    var a, i;
                                    return a = t._rgb, i = e._rgb, new r(_t(nt(a[0], 2) * (1 - n) + nt(i[0], 2) * n), _t(nt(a[1], 2) * (1 - n) + nt(i[1], 2) * n), _t(nt(a[2], 2) * (1 - n) + nt(i[2], 2) * n), o)
                                }, s = function(t) {
                                    var e, n, o, a, i;
                                    for (e = 1 / t.length, i = [0, 0, 0, 0], o = 0, n = t.length; o < n; o++) a = t[o]._rgb, i[0] += nt(a[0], 2) * e, i[1] += nt(a[1], 2) * e, i[2] += nt(a[2], 2) * e, i[3] += a[3] * e;
                                    return i[0] = _t(i[0]), i[1] = _t(i[1]), i[2] = _t(i[2]), i[3] > 1 && (i[3] = 1), new r(k(i))
                                }, p.push(["lrgb", W]), _.average = function(t, e) {
                                    var r, n, o, a, u, f, c, l, h, d, p, b, v;
                                    if (null == e && (e = "rgb"), h = t.length, c = (t = t.map((function(t) {
                                            return _(t)
                                        }))).splice(0, 1)[0], "lrgb" === e) return s(t);
                                    for (l in a = [], u = 0, f = 0, b = c.get(e)) b[l] = b[l] || 0, a.push(isNaN(b[l]) ? 0 : 1), "h" !== e.charAt(l) || isNaN(b[l]) || (r = b[l] / 180 * i, u += M(r), f += xt(r));
                                    for (n = c.alpha(), p = 0, d = t.length; p < d; p++)
                                        for (l in v = (o = t[p]).get(e), n += o.alpha(), b) isNaN(v[l]) || (a[l] += 1, "h" === e.charAt(l) ? (r = v[l] / 180 * i, u += M(r), f += xt(r)) : b[l] += v[l]);
                                    for (l in b)
                                        if ("h" === e.charAt(l)) {
                                            for (r = g(f / a[l], u / a[l]) / i * 180; r < 0;) r += 360;
                                            for (; r >= 360;) r -= 360;
                                            b[l] = r
                                        } else b[l] = b[l] / a[l];
                                    return _(b, e).alpha(n / h)
                                }, T = function(t) {
                                    var e, r;
                                    if (t.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) return 4 !== t.length && 7 !== t.length || (t = t.substr(1)), 3 === t.length && (t = (t = t.split(""))[0] + t[0] + t[1] + t[1] + t[2] + t[2]), [(r = parseInt(t, 16)) >> 16, r >> 8 & 255, 255 & r, 1];
                                    if (t.match(/^#?([A-Fa-f0-9]{8})$/)) return 9 === t.length && (t = t.substr(1)), [(r = parseInt(t, 16)) >> 24 & 255, r >> 16 & 255, r >> 8 & 255, mt((255 & r) / 255 * 100) / 100];
                                    if (null != d.css && (e = d.css(t))) return e;
                                    throw "unknown color: " + t
                                }, ut = function(t, e) {
                                    var r, n, o, a, i, u;
                                    return null == e && (e = "auto"), i = t[0], o = t[1], n = t[2], r = t[3], "auto" === e && (e = r < 1 ? "rgba" : "rgb"), i = Math.round(i), o = Math.round(o), n = Math.round(n), u = (u = "000000" + (i << 16 | o << 8 | n).toString(16)).substr(u.length - 6), a = (a = "0" + mt(255 * r).toString(16)).substr(a.length - 2), "#" + function() {
                                        switch (e.toLowerCase()) {
                                            case "rgba":
                                                return u + a;
                                            case "argb":
                                                return a + u;
                                            default:
                                                return u
                                        }
                                    }()
                                }, d.hex = function(t) {
                                    return T(t)
                                }, _.hex = function() {
                                    return function(t, e, r) {
                                        r.prototype = t.prototype;
                                        var n = new r,
                                            o = t.apply(n, e);
                                        return Object(o) === o ? o : n
                                    }(r, Ot.call(arguments).concat(["hex"]), (function() {}))
                                }, r.prototype.hex = function(t) {
                                    return null == t && (t = "auto"), ut(this._rgb, t)
                                }, l.push({
                                    p: 4,
                                    test: function(t) {
                                        if (1 === arguments.length && "string" === jt(t)) return "hex"
                                    }
                                }), G = function() {
                                    var t, e, r, n, o, a, i, u, f, c, s, l, h, d;
                                    if (o = (t = Mt(arguments))[0], s = t[1], i = t[2], 0 === s) f = n = e = 255 * i;
                                    else {
                                        for (r = [0, 0, 0], l = 2 * i - (h = i < .5 ? i * (1 + s) : i + s - i * s), (d = [0, 0, 0])[0] = (o /= 360) + 1 / 3, d[1] = o, d[2] = o - 1 / 3, a = u = 0; u <= 2; a = ++u) d[a] < 0 && (d[a] += 1), d[a] > 1 && (d[a] -= 1), 6 * d[a] < 1 ? r[a] = l + 6 * (h - l) * d[a] : 2 * d[a] < 1 ? r[a] = h : 3 * d[a] < 2 ? r[a] = l + (h - l) * (2 / 3 - d[a]) * 6 : r[a] = l;
                                        f = (c = [mt(255 * r[0]), mt(255 * r[1]), mt(255 * r[2])])[0], n = c[1], e = c[2]
                                    }
                                    return t.length > 3 ? [f, n, e, t[3]] : [f, n, e]
                                }, ct = function(t, e, r) {
                                    var n, o, a, i, u;
                                    return void 0 !== t && t.length >= 3 && (t = (i = t)[0], e = i[1], r = i[2]), t /= 255, e /= 255, r /= 255, a = Math.min(t, e, r), o = ((Q = Math.max(t, e, r)) + a) / 2, Q === a ? (u = 0, n = Number.NaN) : u = o < .5 ? (Q - a) / (Q + a) : (Q - a) / (2 - Q - a), t === Q ? n = (e - r) / (Q - a) : e === Q ? n = 2 + (r - t) / (Q - a) : r === Q && (n = 4 + (t - e) / (Q - a)), (n *= 60) < 0 && (n += 360), [n, u, o]
                                }, _.hsl = function() {
                                    return function(t, e, r) {
                                        r.prototype = t.prototype;
                                        var n = new r,
                                            o = t.apply(n, e);
                                        return Object(o) === o ? o : n
                                    }(r, Ot.call(arguments).concat(["hsl"]), (function() {}))
                                }, d.hsl = G, r.prototype.hsl = function() {
                                    return ct(this._rgb)
                                }, B = function() {
                                    var t, e, r, n, o, a, i, u, f, c, s, l, h, d, p, b, g, v;
                                    if (o = (t = Mt(arguments))[0], b = t[1], v = t[2], v *= 255, 0 === b) f = n = e = v;
                                    else switch (360 === o && (o = 0), o > 360 && (o -= 360), o < 0 && (o += 360), i = v * (1 - b), u = v * (1 - b * (r = (o /= 60) - (a = P(o)))), g = v * (1 - b * (1 - r)), a) {
                                        case 0:
                                            f = (c = [v, g, i])[0], n = c[1], e = c[2];
                                            break;
                                        case 1:
                                            f = (s = [u, v, i])[0], n = s[1], e = s[2];
                                            break;
                                        case 2:
                                            f = (l = [i, v, g])[0], n = l[1], e = l[2];
                                            break;
                                        case 3:
                                            f = (h = [i, u, v])[0], n = h[1], e = h[2];
                                            break;
                                        case 4:
                                            f = (d = [g, i, v])[0], n = d[1], e = d[2];
                                            break;
                                        case 5:
                                            f = (p = [v, i, u])[0], n = p[1], e = p[2]
                                    }
                                    return [f, n, e, t.length > 3 ? t[3] : 1]
                                }, st = function() {
                                    var t, e, r, n, o, a, i, u, f;
                                    return a = (i = Mt(arguments))[0], r = i[1], t = i[2], o = Math.min(a, r, t), e = (Q = Math.max(a, r, t)) - o, f = Q / 255, 0 === Q ? (n = Number.NaN, u = 0) : (u = e / Q, a === Q && (n = (r - t) / e), r === Q && (n = 2 + (t - a) / e), t === Q && (n = 4 + (a - r) / e), (n *= 60) < 0 && (n += 360)), [n, u, f]
                                }, _.hsv = function() {
                                    return function(t, e, r) {
                                        r.prototype = t.prototype;
                                        var n = new r,
                                            o = t.apply(n, e);
                                        return Object(o) === o ? o : n
                                    }(r, Ot.call(arguments).concat(["hsv"]), (function() {}))
                                }, d.hsv = B, r.prototype.hsv = function() {
                                    return st(this._rgb)
                                }, et = function(t) {
                                    return "number" === jt(t) && t >= 0 && t <= 16777215 ? [t >> 16, t >> 8 & 255, 255 & t, 1] : (console.warn("unknown num color: " + t), [0, 0, 0, 1])
                                }, pt = function() {
                                    var t;
                                    return ((t = Mt(arguments))[0] << 16) + (t[1] << 8) + t[2]
                                }, _.num = function(t) {
                                    return new r(t, "num")
                                }, r.prototype.num = function(t) {
                                    return null == t && (t = "rgb"), pt(this._rgb, t)
                                }, d.num = et, l.push({
                                    p: 1,
                                    test: function(t) {
                                        if (1 === arguments.length && "number" === jt(t) && t >= 0 && t <= 16777215) return "num"
                                    }
                                }), E = function() {
                                    var t, e, r, n, o, a, i, u, f, c, s, l, h, d, p, b, g, v, y, m;
                                    if (u = (r = Mt(arguments))[0], o = r[1], e = r[2], i = i / 100 * 255, t = 255 * (o /= 100), 0 === o) l = i = n = e;
                                    else switch (360 === u && (u = 0), u > 360 && (u -= 360), u < 0 && (u += 360), s = (c = e * (1 - o)) + t * (1 - (a = (u /= 60) - (f = P(u)))), y = c + t * a, m = c + t, f) {
                                        case 0:
                                            l = (h = [m, y, c])[0], i = h[1], n = h[2];
                                            break;
                                        case 1:
                                            l = (d = [s, m, c])[0], i = d[1], n = d[2];
                                            break;
                                        case 2:
                                            l = (p = [c, m, y])[0], i = p[1], n = p[2];
                                            break;
                                        case 3:
                                            l = (b = [c, s, m])[0], i = b[1], n = b[2];
                                            break;
                                        case 4:
                                            l = (g = [y, c, m])[0], i = g[1], n = g[2];
                                            break;
                                        case 5:
                                            l = (v = [m, c, s])[0], i = v[1], n = v[2]
                                    }
                                    return [l, i, n, r.length > 3 ? r[3] : 1]
                                }, it = function() {
                                    var t, e, r, n, o, a, i, u, f;
                                    return u = (f = Mt(arguments))[0], o = f[1], e = f[2], i = Math.min(u, o, e), r = 100 * (n = (Q = Math.max(u, o, e)) - i) / 255, t = i / (255 - n) * 100, 0 === n ? a = Number.NaN : (u === Q && (a = (o - e) / n), o === Q && (a = 2 + (e - u) / n), e === Q && (a = 4 + (u - o) / n), (a *= 60) < 0 && (a += 360)), [a, r, t]
                                }, _.hcg = function() {
                                    return function(t, e, r) {
                                        r.prototype = t.prototype;
                                        var n = new r,
                                            o = t.apply(n, e);
                                        return Object(o) === o ? o : n
                                    }(r, Ot.call(arguments).concat(["hcg"]), (function() {}))
                                }, d.hcg = E, r.prototype.hcg = function() {
                                    return it(this._rgb)
                                }, L = function(t) {
                                    var e, r, n, o, a, i, u, f;
                                    if (t = t.toLowerCase(), null != _.colors && _.colors[t]) return T(_.colors[t]);
                                    if (a = t.match(/rgb\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*\)/)) {
                                        for (u = a.slice(1, 4), o = i = 0; i <= 2; o = ++i) u[o] = +u[o];
                                        u[3] = 1
                                    } else if (a = t.match(/rgba\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*,\s*([01]|[01]?\.\d+)\)/))
                                        for (u = a.slice(1, 5), o = f = 0; f <= 3; o = ++f) u[o] = +u[o];
                                    else if (a = t.match(/rgb\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
                                        for (u = a.slice(1, 4), o = e = 0; e <= 2; o = ++e) u[o] = mt(2.55 * u[o]);
                                        u[3] = 1
                                    } else if (a = t.match(/rgba\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
                                        for (u = a.slice(1, 5), o = r = 0; r <= 2; o = ++r) u[o] = mt(2.55 * u[o]);
                                        u[3] = +u[3]
                                    } else(a = t.match(/hsl\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) ? ((n = a.slice(1, 4))[1] *= .01, n[2] *= .01, (u = G(n))[3] = 1) : (a = t.match(/hsla\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) && ((n = a.slice(1, 4))[1] *= .01, n[2] *= .01, (u = G(n))[3] = +a[4]);
                                    return u
                                }, at = function(t) {
                                    var e;
                                    return "rgb" == (e = t[3] < 1 ? "rgba" : "rgb") ? e + "(" + t.slice(0, 3).map(mt).join(",") + ")" : "rgba" === e ? e + "(" + t.slice(0, 3).map(mt).join(",") + "," + t[3] + ")" : void 0
                                }, yt = function(t) {
                                    return mt(100 * t) / 100
                                }, R = function(t, e) {
                                    var r;
                                    return r = e < 1 ? "hsla" : "hsl", t[0] = yt(t[0] || 0), t[1] = yt(100 * t[1]) + "%", t[2] = yt(100 * t[2]) + "%", "hsla" === r && (t[3] = e), r + "(" + t.join(",") + ")"
                                }, d.css = function(t) {
                                    return L(t)
                                }, _.css = function() {
                                    return function(t, e, r) {
                                        r.prototype = t.prototype;
                                        var n = new r,
                                            o = t.apply(n, e);
                                        return Object(o) === o ? o : n
                                    }(r, Ot.call(arguments).concat(["css"]), (function() {}))
                                }, r.prototype.css = function(t) {
                                    return null == t && (t = "rgb"), "rgb" === t.slice(0, 3) ? at(this._rgb) : "hsl" === t.slice(0, 3) ? R(this.hsl(), this.alpha()) : void 0
                                }, d.named = function(t) {
                                    return T(Lt[t])
                                }, l.push({
                                    p: 5,
                                    test: function(t) {
                                        if (1 === arguments.length && null != Lt[t]) return "named"
                                    }
                                }), r.prototype.name = function(t) {
                                    var e, r;
                                    for (r in arguments.length && (Lt[t] && (this._rgb = T(Lt[t])), this._rgb[3] = 1), e = this.hex("rgb"), Lt)
                                        if (e === Lt[r]) return r;
                                    return e
                                }, X = function() {
                                    var t, e, r, n;
                                    return r = (n = Mt(arguments))[0], t = n[1], e = n[2], [r, M(e *= o) * t, xt(e) * t]
                                }, D = function() {
                                    var t, e, r, n, o, a, i, u, f;
                                    return i = (r = Mt(arguments))[0], o = r[1], a = r[2], t = (u = X(i, o, a))[0], e = u[1], n = u[2], [(f = Y(t, e, n))[0], f[1], n = f[2], r.length > 3 ? r[3] : 1]
                                }, q = function() {
                                    var t, e, r, n, o, a;
                                    return o = (a = Mt(arguments))[0], t = a[1], e = a[2], r = _t(t * t + e * e), n = (g(e, t) * f + 360) % 360, 0 === mt(1e4 * r) && (n = Number.NaN), [o, r, n]
                                }, ht = function() {
                                    var t, e, r, n, o, a, i;
                                    return o = (a = Mt(arguments))[0], r = a[1], e = a[2], n = (i = lt(o, r, e))[0], t = i[1], e = i[2], q(n, t, e)
                                }, _.lch = function() {
                                    var t;
                                    return t = Mt(arguments), new r(t, "lch")
                                }, _.hcl = function() {
                                    var t;
                                    return t = Mt(arguments), new r(t, "hcl")
                                }, d.lch = D, d.hcl = function() {
                                    var t, e, r, n;
                                    return e = (n = Mt(arguments))[0], t = n[1], r = n[2], D([r, t, e])
                                }, r.prototype.lch = function() {
                                    return ht(this._rgb)
                                }, r.prototype.hcl = function() {
                                    return ht(this._rgb).reverse()
                                }, ot = function(t) {
                                    var e, r, n, o, a, i;
                                    return null == t && (t = "rgb"), a = (i = Mt(arguments))[0], n = i[1], e = i[2], n /= 255, e /= 255, [(1 - (a /= 255) - (o = 1 - Math.max(a, Math.max(n, e)))) * (r = o < 1 ? 1 / (1 - o) : 0), (1 - n - o) * r, (1 - e - o) * r, o]
                                }, j = function() {
                                    var t, e, r, n, o, a;
                                    return r = (e = Mt(arguments))[0], o = e[1], a = e[2], n = e[3], t = e.length > 4 ? e[4] : 1, 1 === n ? [0, 0, 0, t] : [r >= 1 ? 0 : 255 * (1 - r) * (1 - n), o >= 1 ? 0 : 255 * (1 - o) * (1 - n), a >= 1 ? 0 : 255 * (1 - a) * (1 - n), t]
                                }, d.cmyk = function() {
                                    return j(Mt(arguments))
                                }, _.cmyk = function() {
                                    return function(t, e, r) {
                                        r.prototype = t.prototype;
                                        var n = new r,
                                            o = t.apply(n, e);
                                        return Object(o) === o ? o : n
                                    }(r, Ot.call(arguments).concat(["cmyk"]), (function() {}))
                                }, r.prototype.cmyk = function() {
                                    return ot(this._rgb)
                                }, d.gl = function() {
                                    var t, e, r, n, o;
                                    for (n = function() {
                                            var t, r;
                                            for (e in r = [], t = Mt(arguments)) o = t[e], r.push(o);
                                            return r
                                        }.apply(this, arguments), t = r = 0; r <= 2; t = ++r) n[t] *= 255;
                                    return n
                                }, _.gl = function() {
                                    return function(t, e, r) {
                                        r.prototype = t.prototype;
                                        var n = new r,
                                            o = t.apply(n, e);
                                        return Object(o) === o ? o : n
                                    }(r, Ot.call(arguments).concat(["gl"]), (function() {}))
                                }, r.prototype.gl = function() {
                                    var t;
                                    return [(t = this._rgb)[0] / 255, t[1] / 255, t[2] / 255, t[3]]
                                }, dt = function(t, e, r) {
                                    var n;
                                    return t = (n = Mt(arguments))[0], e = n[1], r = n[2], .2126 * (t = K(t)) + .7152 * (e = K(e)) + .0722 * K(r)
                                }, K = function(t) {
                                    return (t /= 255) <= .03928 ? t / 12.92 : nt((t + .055) / 1.055, 2.4)
                                }, I = function(t, e, n, o) {
                                    var a, i;
                                    return a = t._rgb, i = e._rgb, new r(a[0] + n * (i[0] - a[0]), a[1] + n * (i[1] - a[1]), a[2] + n * (i[2] - a[2]), o)
                                }, p.push(["rgb", I]), r.prototype.luminance = function(t, e) {
                                    var r, n, o, a, i;
                                    return null == e && (e = "rgb"), arguments.length ? (a = this._rgb, 0 === t ? a = [0, 0, 0, this._rgb[3]] : 1 === t ? a = [255, 255, 255, this[3]] : (r = dt(this._rgb), n = 1e-7, o = 20, i = function(r, a) {
                                        var u, f;
                                        return u = (f = r.interpolate(a, .5, e)).luminance(), Math.abs(t - u) < n || !o-- ? f : u > t ? i(r, f) : i(f, a)
                                    }, a = r > t ? i(_("black"), this).rgba() : i(this, _("white")).rgba()), _(a).alpha(this.alpha())) : dt(this._rgb)
                                }, kt = function(t) {
                                    var e, r, n, o;
                                    return (o = t / 100) < 66 ? (n = 255, r = -155.25485562709179 - .44596950469579133 * (r = o - 2) + 104.49216199393888 * $(r), e = o < 20 ? 0 : .8274096064007395 * (e = o - 10) - 254.76935184120902 + 115.67994401066147 * $(e)) : (n = 351.97690566805693 + .114206453784165 * (n = o - 55) - 40.25366309332127 * $(n), r = 325.4494125711974 + .07943456536662342 * (r = o - 50) - 28.0852963507957 * $(r), e = 255), [n, r, e]
                                }, bt = function() {
                                    var t, e, r, n, o, a, i, u;
                                    for (o = (a = Mt(arguments))[0], a[1], t = a[2], n = 1e3, r = 4e4, e = .4; r - n > e;)(i = kt(u = .5 * (r + n)))[2] / i[0] >= t / o ? r = u : n = u;
                                    return mt(u)
                                }, _.temperature = _.kelvin = function() {
                                    return function(t, e, r) {
                                        r.prototype = t.prototype;
                                        var n = new r,
                                            o = t.apply(n, e);
                                        return Object(o) === o ? o : n
                                    }(r, Ot.call(arguments).concat(["temperature"]), (function() {}))
                                }, d.temperature = d.kelvin = d.K = kt, r.prototype.temperature = function() {
                                    return bt(this._rgb)
                                }, r.prototype.kelvin = r.prototype.temperature, _.contrast = function(t, e) {
                                    var n, o, a, i;
                                    return "string" !== (a = jt(t)) && "number" !== a || (t = new r(t)), "string" !== (i = jt(e)) && "number" !== i || (e = new r(e)), (n = t.luminance()) > (o = e.luminance()) ? (n + .05) / (o + .05) : (o + .05) / (n + .05)
                                }, _.distance = function(t, e, n) {
                                    var o, a, i, u, f, c, s;
                                    for (a in null == n && (n = "lab"), "string" !== (f = jt(t)) && "number" !== f || (t = new r(t)), "string" !== (c = jt(e)) && "number" !== c || (e = new r(e)), i = t.get(n), u = e.get(n), s = 0, i) s += (o = (i[a] || 0) - (u[a] || 0)) * o;
                                    return Math.sqrt(s)
                                }, _.deltaE = function(t, e, n, o) {
                                    var a, u, f, c, s, l, h, d, p, v, y, m, w, x, _, k, j, L, N, S, O, P, E, T;
                                    for (null == n && (n = 1), null == o && (o = 1), "string" !== (_ = jt(t)) && "number" !== _ || (t = new r(t)), "string" !== (k = jt(e)) && "number" !== k || (e = new r(e)), a = (j = t.lab())[0], f = j[1], s = j[2], u = (L = e.lab())[0], c = L[1], l = L[2], h = _t(f * f + s * s), d = _t(c * c + l * l), S = a < 16 ? .511 : .040975 * a / (1 + .01765 * a), N = .0638 * h / (1 + .0131 * h) + .638, x = h < 1e-6 ? 0 : 180 * g(s, f) / i; x < 0;) x += 360;
                                    for (; x >= 360;) x -= 360;
                                    return O = x >= 164 && x <= 345 ? .56 + b(.2 * M(i * (x + 168) / 180)) : .36 + b(.4 * M(i * (x + 35) / 180)), w = _t((p = h * h * h * h) / (p + 1900)), _t((P = (a - u) / (n * S)) * P + (E = (m = h - d) / (o * N)) * E + ((v = f - c) * v + (y = s - l) * y - m * m) / ((T = N * (w * O + 1 - w)) * T))
                                }, r.prototype.get = function(t) {
                                    var e, r, n, o, a;
                                    return n = (o = t.split("."))[0], e = o[1], a = this[n](), e ? (r = n.indexOf(e)) > -1 ? a[r] : console.warn("unknown channel " + e + " in mode " + n) : a
                                }, r.prototype.set = function(t, e) {
                                    var r, n, o, a, i;
                                    if (o = (a = t.split("."))[0], r = a[1])
                                        if (i = this[o](), (n = o.indexOf(r)) > -1)
                                            if ("string" === jt(e)) switch (e.charAt(0)) {
                                                case "+":
                                                case "-":
                                                    i[n] += +e;
                                                    break;
                                                case "*":
                                                    i[n] *= +e.substr(1);
                                                    break;
                                                case "/":
                                                    i[n] /= +e.substr(1);
                                                    break;
                                                default:
                                                    i[n] = +e
                                            } else i[n] = e;
                                            else console.warn("unknown channel " + r + " in mode " + o);
                                    else i = e;
                                    return _(i, o).alpha(this.alpha())
                                }, r.prototype.clipped = function() {
                                    return this._rgb._clipped || !1
                                }, r.prototype.alpha = function(t) {
                                    return arguments.length ? _.rgb([this._rgb[0], this._rgb[1], this._rgb[2], t]) : this._rgb[3]
                                }, r.prototype.darken = function(t) {
                                    var e;
                                    return null == t && (t = 1), (e = this.lab())[0] -= a.Kn * t, _.lab(e).alpha(this.alpha())
                                }, r.prototype.brighten = function(t) {
                                    return null == t && (t = 1), this.darken(-t)
                                }, r.prototype.darker = r.prototype.darken, r.prototype.brighter = r.prototype.brighten, r.prototype.saturate = function(t) {
                                    var e;
                                    return null == t && (t = 1), (e = this.lch())[1] += t * a.Kn, e[1] < 0 && (e[1] = 0), _.lch(e).alpha(this.alpha())
                                }, r.prototype.desaturate = function(t) {
                                    return null == t && (t = 1), this.saturate(-t)
                                }, r.prototype.premultiply = function() {
                                    var t, e;
                                    return e = this.rgb(), t = this.alpha(), _(e[0] * t, e[1] * t, e[2] * t, t)
                                }, tt = function(t, e) {
                                    return t * e / 255
                                }, N = function(t, e) {
                                    return t > e ? e : t
                                }, H = function(t, e) {
                                    return t > e ? t : e
                                }, wt = function(t, e) {
                                    return 255 * (1 - (1 - t / 255) * (1 - e / 255))
                                }, rt = function(t, e) {
                                    return e < 128 ? 2 * t * e / 255 : 255 * (1 - 2 * (1 - t / 255) * (1 - e / 255))
                                }, x = function(t, e) {
                                    return 255 * (1 - (1 - e / 255) / (t / 255))
                                }, S = function(t, e) {
                                    return 255 === t || (t = e / 255 * 255 / (1 - t / 255)) > 255 ? 255 : t
                                }, (y = function(t, e, r) {
                                    if (!y[r]) throw "unknown blend mode " + r;
                                    return y[r](t, e)
                                }).normal = (m = function(t) {
                                    return function(e, r) {
                                        var n, o;
                                        return n = _(r).rgb(), o = _(e).rgb(), _(t(n, o), "rgb")
                                    }
                                })((O = function(t) {
                                    return function(e, r) {
                                        var n, o, a;
                                        for (a = [], n = o = 0; o <= 3; n = ++o) a[n] = t(e[n], r[n]);
                                        return a
                                    }
                                })((function(t, e) {
                                    return t
                                }))), y.multiply = m(O(tt)), y.screen = m(O(wt)), y.overlay = m(O(rt)), y.darken = m(O(N)), y.lighten = m(O(H)), y.dodge = m(O(S)), y.burn = m(O(x)), _.blend = y, _.analyze = function(t) {
                                    var e, r, n, o;
                                    for (n = {
                                            min: Number.MAX_VALUE,
                                            max: -1 * Number.MAX_VALUE,
                                            sum: 0,
                                            values: [],
                                            count: 0
                                        }, r = 0, e = t.length; r < e; r++) null == (o = t[r]) || isNaN(o) || (n.values.push(o), n.sum += o, o < n.min && (n.min = o), o > n.max && (n.max = o), n.count += 1);
                                    return n.domain = [n.min, n.max], n.limits = function(t, e) {
                                        return _.limits(n, t, e)
                                    }, n
                                }, _.scale = function(t, e) {
                                    var r, n, o, a, i, u, f, c, s, l, h, d, p, b, g, v, y, m, w, x, k;
                                    return s = "rgb", l = _("#ccc"), b = 0, i = [0, 1], p = [], d = [0, 0], r = !1, o = [], h = !1, c = 0, f = 1, a = !1, n = {}, g = !0, u = 1, x = function(t) {
                                        var e, r, n, a, i, u;
                                        if (null == t && (t = ["#fff", "#212121"]), null != t && "string" === jt(t) && null != _.brewer && (t = _.brewer[t] || _.brewer[t.toLowerCase()] || t), "array" === jt(t)) {
                                            for (1 === t.length && (t = [t[0], t[0]]), e = n = 0, a = (t = t.slice(0)).length - 1; 0 <= a ? n <= a : n >= a; e = 0 <= a ? ++n : --n) r = t[e], "string" === jt(r) && (t[e] = _(r));
                                            for (p.length = 0, e = u = 0, i = t.length - 1; 0 <= i ? u <= i : u >= i; e = 0 <= i ? ++u : --u) p.push(e / (t.length - 1))
                                        }
                                        return w(), o = t
                                    }, y = function(t) {
                                        var e, n;
                                        if (null != r) {
                                            for (n = r.length - 1, e = 0; e < n && t >= r[e];) e++;
                                            return e - 1
                                        }
                                        return 0
                                    }, k = function(t) {
                                        return t
                                    }, m = function(t, e) {
                                        var a, i, h, b, v, m, w;
                                        if (null == e && (e = !1), isNaN(t) || null === t) return l;
                                        if (w = e ? t : r && r.length > 2 ? y(t) / (r.length - 2) : f !== c ? (t - c) / (f - c) : 1, e || (w = k(w)), 1 !== u && (w = nt(w, u)), w = d[0] + w * (1 - d[0] - d[1]), w = Math.min(1, Math.max(0, w)), h = Math.floor(1e4 * w), g && n[h]) a = n[h];
                                        else {
                                            if ("array" === jt(o))
                                                for (i = b = 0, m = p.length - 1; 0 <= m ? b <= m : b >= m; i = 0 <= m ? ++b : --b) {
                                                    if (w <= (v = p[i])) {
                                                        a = o[i];
                                                        break
                                                    }
                                                    if (w >= v && i === p.length - 1) {
                                                        a = o[i];
                                                        break
                                                    }
                                                    if (w > v && w < p[i + 1]) {
                                                        w = (w - v) / (p[i + 1] - v), a = _.interpolate(o[i], o[i + 1], w, s);
                                                        break
                                                    }
                                                } else "function" === jt(o) && (a = o(w));
                                            g && (n[h] = a)
                                        }
                                        return a
                                    }, w = function() {
                                        return n = {}
                                    }, x(t), (v = function(t) {
                                        var e;
                                        return e = _(m(t)), h && e[h] ? e[h]() : e
                                    }).classes = function(t) {
                                        var e;
                                        return null != t ? ("array" === jt(t) ? (r = t, i = [t[0], t[t.length - 1]]) : (e = _.analyze(i), r = 0 === t ? [e.min, e.max] : _.limits(e, "e", t)), v) : r
                                    }, v.domain = function(t) {
                                        var e, r, n, a, u, s, l;
                                        if (!arguments.length) return i;
                                        if (c = t[0], f = t[t.length - 1], p = [], n = o.length, t.length === n && c !== f)
                                            for (u = 0, a = t.length; u < a; u++) r = t[u], p.push((r - c) / (f - c));
                                        else
                                            for (e = l = 0, s = n - 1; 0 <= s ? l <= s : l >= s; e = 0 <= s ? ++l : --l) p.push(e / (n - 1));
                                        return i = [c, f], v
                                    }, v.mode = function(t) {
                                        return arguments.length ? (s = t, w(), v) : s
                                    }, v.range = function(t, e) {
                                        return x(t), v
                                    }, v.out = function(t) {
                                        return h = t, v
                                    }, v.spread = function(t) {
                                        return arguments.length ? (b = t, v) : b
                                    }, v.correctLightness = function(t) {
                                        return null == t && (t = !0), a = t, w(), k = a ? function(t) {
                                            var e, r, n, o, a, i, u, f;
                                            for (i = (e = m(0, !0).lab()[0]) > (r = m(1, !0).lab()[0]), n = m(t, !0).lab()[0] - (o = e + (r - e) * t), u = 0, f = 1, a = 20; Math.abs(n) > .01 && a-- > 0;) i && (n *= -1), n < 0 ? (u = t, t += .5 * (f - t)) : (f = t, t += .5 * (u - t)), n = m(t, !0).lab()[0] - o;
                                            return t
                                        } : function(t) {
                                            return t
                                        }, v
                                    }, v.padding = function(t) {
                                        return null != t ? ("number" === jt(t) && (t = [t, t]), d = t, v) : d
                                    }, v.colors = function(e, n) {
                                        var a, u, f, c, s, l, h, d;
                                        if (arguments.length < 2 && (n = "hex"), s = [], 0 === arguments.length) s = o.slice(0);
                                        else if (1 === e) s = [v(.5)];
                                        else if (e > 1) u = i[0], a = i[1] - u, s = function() {
                                            l = [];
                                            for (var t = 0; 0 <= e ? t < e : t > e; 0 <= e ? t++ : t--) l.push(t);
                                            return l
                                        }.apply(this).map((function(t) {
                                            return v(u + t / (e - 1) * a)
                                        }));
                                        else {
                                            if (t = [], h = [], r && r.length > 2)
                                                for (f = d = 1, c = r.length; 1 <= c ? d < c : d > c; f = 1 <= c ? ++d : --d) h.push(.5 * (r[f - 1] + r[f]));
                                            else h = i;
                                            s = h.map((function(t) {
                                                return v(t)
                                            }))
                                        }
                                        return _[n] && (s = s.map((function(t) {
                                            return t[n]()
                                        }))), s
                                    }, v.cache = function(t) {
                                        return null != t ? (g = t, v) : g
                                    }, v.gamma = function(t) {
                                        return null != t ? (u = t, v) : u
                                    }, v.nodata = function(t) {
                                        return null != t ? (l = _(t), v) : l
                                    }, v
                                }, null == _.scales && (_.scales = {}), _.scales.cool = function() {
                                    return _.scale([_.hsl(180, 1, .9), _.hsl(250, .7, .4)])
                                }, _.scales.hot = function() {
                                    return _.scale(["#212121", "#f00", "#ff0", "#fff"], [0, .25, .75, 1]).mode("rgb")
                                }, _.analyze = function(t, e, r) {
                                    var n, o, a, i, u, f;
                                    if (u = {
                                            min: Number.MAX_VALUE,
                                            max: -1 * Number.MAX_VALUE,
                                            sum: 0,
                                            values: [],
                                            count: 0
                                        }, null == r && (r = function() {
                                            return !0
                                        }), n = function(t) {
                                            null == t || isNaN(t) || (u.values.push(t), u.sum += t, t < u.min && (u.min = t), t > u.max && (u.max = t), u.count += 1)
                                        }, f = function(t, o) {
                                            if (r(t, o)) return null != e && "function" === jt(e) ? n(e(t)) : null != e && "string" === jt(e) || "number" === jt(e) ? n(t[e]) : n(t)
                                        }, "array" === jt(t))
                                        for (i = 0, a = t.length; i < a; i++) f(t[i]);
                                    else
                                        for (o in t) f(t[o], o);
                                    return u.domain = [u.min, u.max], u.limits = function(t, e) {
                                        return _.limits(u, t, e)
                                    }, u
                                }, _.limits = function(t, e, r) {
                                    var n, o, a, i, u, f, c, s, l, h, d, p, g, v, y, m, w, x, k, j, M, L, N, S, O, E, T, A, R, G, B, C, F, z, W, V, I, q, Y, U, X, D, H, Z, K, J, tt, et, rt, ot, at, it, ut, ft, ct;
                                    if (null == e && (e = "equal"), null == r && (r = 7), "array" === jt(t) && (t = _.analyze(t)), O = t.min, Q = t.max, t.sum, ft = t.values.sort((function(t, e) {
                                            return t - e
                                        })), 1 === r) return [O, Q];
                                    if (N = [], "c" === e.substr(0, 1) && (N.push(O), N.push(Q)), "e" === e.substr(0, 1)) {
                                        for (N.push(O), j = B = 1, W = r - 1; 1 <= W ? B <= W : B >= W; j = 1 <= W ? ++B : --B) N.push(O + j / r * (Q - O));
                                        N.push(Q)
                                    } else if ("l" === e.substr(0, 1)) {
                                        if (O <= 0) throw "Logarithmic scales are only possible for values > 0";
                                        for (E = Math.LOG10E * $(O), S = Math.LOG10E * $(Q), N.push(O), j = ct = 1, V = r - 1; 1 <= V ? ct <= V : ct >= V; j = 1 <= V ? ++ct : --ct) N.push(nt(10, E + j / r * (S - E)));
                                        N.push(Q)
                                    } else if ("q" === e.substr(0, 1)) {
                                        for (N.push(O), j = n = 1, D = r - 1; 1 <= D ? n <= D : n >= D; j = 1 <= D ? ++n : --n) C = (ft.length - 1) * j / r, (F = P(C)) === C ? N.push(ft[F]) : (z = C - F, N.push(ft[F] * (1 - z) + ft[F + 1] * z));
                                        N.push(Q)
                                    } else if ("k" === e.substr(0, 1)) {
                                        for (A = ft.length, v = new Array(A), x = new Array(r), ot = !0, R = 0, m = null, (m = []).push(O), j = o = 1, H = r - 1; 1 <= H ? o <= H : o >= H; j = 1 <= H ? ++o : --o) m.push(O + j / r * (Q - O));
                                        for (m.push(Q); ot;) {
                                            for (M = a = 0, Z = r - 1; 0 <= Z ? a <= Z : a >= Z; M = 0 <= Z ? ++a : --a) x[M] = 0;
                                            for (j = i = 0, K = A - 1; 0 <= K ? i <= K : i >= K; j = 0 <= K ? ++i : --i) {
                                                for (ut = ft[j], T = Number.MAX_VALUE, M = u = 0, J = r - 1; 0 <= J ? u <= J : u >= J; M = 0 <= J ? ++u : --u)(k = b(m[M] - ut)) < T && (T = k, y = M);
                                                x[y]++, v[j] = y
                                            }
                                            for (G = new Array(r), M = f = 0, tt = r - 1; 0 <= tt ? f <= tt : f >= tt; M = 0 <= tt ? ++f : --f) G[M] = null;
                                            for (j = c = 0, et = A - 1; 0 <= et ? c <= et : c >= et; j = 0 <= et ? ++c : --c) null === G[w = v[j]] ? G[w] = ft[j] : G[w] += ft[j];
                                            for (M = s = 0, rt = r - 1; 0 <= rt ? s <= rt : s >= rt; M = 0 <= rt ? ++s : --s) G[M] *= 1 / x[M];
                                            for (ot = !1, M = l = 0, I = r - 1; 0 <= I ? l <= I : l >= I; M = 0 <= I ? ++l : --l)
                                                if (G[M] !== m[j]) {
                                                    ot = !0;
                                                    break
                                                } m = G, ++R > 200 && (ot = !1)
                                        }
                                        for (L = {}, M = h = 0, q = r - 1; 0 <= q ? h <= q : h >= q; M = 0 <= q ? ++h : --h) L[M] = [];
                                        for (j = d = 0, Y = A - 1; 0 <= Y ? d <= Y : d >= Y; j = 0 <= Y ? ++d : --d) L[w = v[j]].push(ft[j]);
                                        for (at = [], M = p = 0, U = r - 1; 0 <= U ? p <= U : p >= U; M = 0 <= U ? ++p : --p) at.push(L[M][0]), at.push(L[M][L[M].length - 1]);
                                        for (at = at.sort((function(t, e) {
                                                return t - e
                                            })), N.push(at[0]), j = g = 1, X = at.length - 1; g <= X; j = g += 2) it = at[j], isNaN(it) || -1 !== N.indexOf(it) || N.push(it)
                                    }
                                    return N
                                }, A = function(t, e, r) {
                                    var n, o, a, i;
                                    return t = (n = Mt(arguments))[0], e = n[1], r = n[2], isNaN(t) && (t = 0), (t /= 360) < 1 / 3 ? a = 1 - ((o = (1 - e) / 3) + (i = (1 + e * M(c * t) / M(u - c * t)) / 3)) : t < 2 / 3 ? o = 1 - ((i = (1 - e) / 3) + (a = (1 + e * M(c * (t -= 1 / 3)) / M(u - c * t)) / 3)) : i = 1 - ((a = (1 - e) / 3) + (o = (1 + e * M(c * (t -= 2 / 3)) / M(u - c * t)) / 3)), [255 * (i = Z(r * i * 3)), 255 * (a = Z(r * a * 3)), 255 * (o = Z(r * o * 3)), n.length > 3 ? n[3] : 1]
                                }, ft = function() {
                                    var t, e, r, n, o, a, i;
                                    return o = (a = Mt(arguments))[0], e = a[1], t = a[2], c = 2 * Math.PI, o /= 255, e /= 255, t /= 255, 0 == (i = 1 - Math.min(o, e, t) / (n = (o + e + t) / 3)) ? r = 0 : (r = (o - e + (o - t)) / 2, r /= Math.sqrt((o - e) * (o - e) + (o - t) * (e - t)), r = Math.acos(r), t > e && (r = c - r), r /= c), [360 * r, i, n]
                                }, _.hsi = function() {
                                    return function(t, e, r) {
                                        r.prototype = t.prototype;
                                        var n = new r,
                                            o = t.apply(n, e);
                                        return Object(o) === o ? o : n
                                    }(r, Ot.call(arguments).concat(["hsi"]), (function() {}))
                                }, d.hsi = A, r.prototype.hsi = function() {
                                    return ft(this._rgb)
                                }, F = function(t, e, r, n) {
                                    var o, a, i, u, f, c, s, l, h, d;
                                    return "hsl" === n ? (h = t.hsl(), d = e.hsl()) : "hsv" === n ? (h = t.hsv(), d = e.hsv()) : "hcg" === n ? (h = t.hcg(), d = e.hcg()) : "hsi" === n ? (h = t.hsi(), d = e.hsi()) : "lch" !== n && "hcl" !== n || (n = "hcl", h = t.hcl(), d = e.hcl()), "h" === n.substr(0, 1) && (a = h[0], s = h[1], u = h[2], i = d[0], l = d[1], f = d[2]), isNaN(a) || isNaN(i) ? isNaN(a) ? isNaN(i) ? o = Number.NaN : (o = i, 1 !== u && 0 !== u || "hsv" === n || (c = l)) : (o = a, 1 !== f && 0 !== f || "hsv" === n || (c = s)) : o = a + r * (i > a && i - a > 180 ? i - (a + 360) : i < a && a - i > 180 ? i + 360 - a : i - a), null == c && (c = s + r * (l - s)), _[n](o, c, u + r * (f - u))
                                }, V = function(t, e, r, n) {
                                    var o, a;
                                    return o = t.num(), a = e.num(), _.num(o + (a - o) * r, "num")
                                }, (p = p.concat(function() {
                                    var t, e, r, n;
                                    for (n = [], e = 0, t = (r = ["hsv", "hsl", "hsi", "hcl", "lch", "hcg"]).length; e < t; e++) J = r[e], n.push([J, F]);
                                    return n
                                }())).push(["num", V]), z = function(t, e, n, o) {
                                    var a, i;
                                    return a = t.lab(), i = e.lab(), new r(a[0] + n * (i[0] - a[0]), a[1] + n * (i[1] - a[1]), a[2] + n * (i[2] - a[2]), o)
                                }, p.push(["lab", z])
                        }.call(this)
                },
                588: t => {
                    var e = function(t) {
                        "use strict";
                        var e, r = Object.prototype,
                            n = r.hasOwnProperty,
                            o = "function" == typeof Symbol ? Symbol : {},
                            a = o.iterator || "@@iterator",
                            i = o.asyncIterator || "@@asyncIterator",
                            u = o.toStringTag || "@@toStringTag";
                        function f(t, e, r) {
                            return Object.defineProperty(t, e, {
                                value: r,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }), t[e]
                        }
                        try {
                            f({}, "")
                        } catch (t) {
                            f = function(t, e, r) {
                                return t[e] = r
                            }
                        }
                        function c(t, e, r, n) {
                            var o = e && e.prototype instanceof g ? e : g,
                                a = Object.create(o.prototype),
                                i = new S(n || []);
                            return a._invoke = function(t, e, r) {
                                var n = l;
                                return function(o, a) {
                                    if (n === d) throw new Error("Generator is already running");
                                    if (n === p) {
                                        if ("throw" === o) throw a;
                                        return P()
                                    }
                                    for (r.method = o, r.arg = a;;) {
                                        var i = r.delegate;
                                        if (i) {
                                            var u = M(i, r);
                                            if (u) {
                                                if (u === b) continue;
                                                return u
                                            }
                                        }
                                        if ("next" === r.method) r.sent = r._sent = r.arg;
                                        else if ("throw" === r.method) {
                                            if (n === l) throw n = p, r.arg;
                                            r.dispatchException(r.arg)
                                        } else "return" === r.method && r.abrupt("return", r.arg);
                                        n = d;
                                        var f = s(t, e, r);
                                        if ("normal" === f.type) {
                                            if (n = r.done ? p : h, f.arg === b) continue;
                                            return {
                                                value: f.arg,
                                                done: r.done
                                            }
                                        }
                                        "throw" === f.type && (n = p, r.method = "throw", r.arg = f.arg)
                                    }
                                }
                            }(t, r, i), a
                        }
                        function s(t, e, r) {
                            try {
                                return {
                                    type: "normal",
                                    arg: t.call(e, r)
                                }
                            } catch (t) {
                                return {
                                    type: "throw",
                                    arg: t
                                }
                            }
                        }
                        t.wrap = c;
                        var l = "suspendedStart",
                            h = "suspendedYield",
                            d = "executing",
                            p = "completed",
                            b = {};
                        function g() {}
                        function v() {}
                        function y() {}
                        var m = {};
                        m[a] = function() {
                            return this
                        };
                        var w = Object.getPrototypeOf,
                            x = w && w(w(O([])));
                        x && x !== r && n.call(x, a) && (m = x);
                        var _ = y.prototype = g.prototype = Object.create(m);
                        function k(t) {
                            ["next", "throw", "return"].forEach((function(e) {
                                f(t, e, (function(t) {
                                    return this._invoke(e, t)
                                }))
                            }))
                        }
                        function j(t, e) {
                            function r(o, a, i, u) {
                                var f = s(t[o], t, a);
                                if ("throw" !== f.type) {
                                    var c = f.arg,
                                        l = c.value;
                                    return l && "object" == typeof l && n.call(l, "__await") ? e.resolve(l.__await).then((function(t) {
                                        r("next", t, i, u)
                                    }), (function(t) {
                                        r("throw", t, i, u)
                                    })) : e.resolve(l).then((function(t) {
                                        c.value = t, i(c)
                                    }), (function(t) {
                                        return r("throw", t, i, u)
                                    }))
                                }
                                u(f.arg)
                            }
                            var o;
                            this._invoke = function(t, n) {
                                function a() {
                                    return new e((function(e, o) {
                                        r(t, n, e, o)
                                    }))
                                }
                                return o = o ? o.then(a, a) : a()
                            }
                        }
                        function M(t, r) {
                            var n = t.iterator[r.method];
                            if (n === e) {
                                if (r.delegate = null, "throw" === r.method) {
                                    if (t.iterator.return && (r.method = "return", r.arg = e, M(t, r), "throw" === r.method)) return b;
                                    r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method")
                                }
                                return b
                            }
                            var o = s(n, t.iterator, r.arg);
                            if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, b;
                            var a = o.arg;
                            return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, b) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, b)
                        }
                        function L(t) {
                            var e = {
                                tryLoc: t[0]
                            };
                            1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e)
                        }
                        function N(t) {
                            var e = t.completion || {};
                            e.type = "normal", delete e.arg, t.completion = e
                        }
                        function S(t) {
                            this.tryEntries = [{
                                tryLoc: "root"
                            }], t.forEach(L, this), this.reset(!0)
                        }
                        function O(t) {
                            if (t) {
                                var r = t[a];
                                if (r) return r.call(t);
                                if ("function" == typeof t.next) return t;
                                if (!isNaN(t.length)) {
                                    var o = -1,
                                        i = function r() {
                                            for (; ++o < t.length;)
                                                if (n.call(t, o)) return r.value = t[o], r.done = !1, r;
                                            return r.value = e, r.done = !0, r
                                        };
                                    return i.next = i
                                }
                            }
                            return {
                                next: P
                            }
                        }
                        function P() {
                            return {
                                value: e,
                                done: !0
                            }
                        }
                        return v.prototype = _.constructor = y, y.constructor = v, v.displayName = f(y, u, "GeneratorFunction"), t.isGeneratorFunction = function(t) {
                            var e = "function" == typeof t && t.constructor;
                            return !!e && (e === v || "GeneratorFunction" === (e.displayName || e.name))
                        }, t.mark = function(t) {
                            return Object.setPrototypeOf ? Object.setPrototypeOf(t, y) : (t.__proto__ = y, f(t, u, "GeneratorFunction")), t.prototype = Object.create(_), t
                        }, t.awrap = function(t) {
                            return {
                                __await: t
                            }
                        }, k(j.prototype), j.prototype[i] = function() {
                            return this
                        }, t.AsyncIterator = j, t.async = function(e, r, n, o, a) {
                            void 0 === a && (a = Promise);
                            var i = new j(c(e, r, n, o), a);
                            return t.isGeneratorFunction(r) ? i : i.next().then((function(t) {
                                return t.done ? t.value : i.next()
                            }))
                        }, k(_), f(_, u, "Generator"), _[a] = function() {
                            return this
                        }, _.toString = function() {
                            return "[object Generator]"
                        }, t.keys = function(t) {
                            var e = [];
                            for (var r in t) e.push(r);
                            return e.reverse(),
                                function r() {
                                    for (; e.length;) {
                                        var n = e.pop();
                                        if (n in t) return r.value = n, r.done = !1, r
                                    }
                                    return r.done = !0, r
                                }
                        }, t.values = O, S.prototype = {
                            constructor: S,
                            reset: function(t) {
                                if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(N), !t)
                                    for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e)
                            },
                            stop: function() {
                                this.done = !0;
                                var t = this.tryEntries[0].completion;
                                if ("throw" === t.type) throw t.arg;
                                return this.rval
                            },
                            dispatchException: function(t) {
                                if (this.done) throw t;
                                var r = this;
                                function o(n, o) {
                                    return u.type = "throw", u.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o
                                }
                                for (var a = this.tryEntries.length - 1; a >= 0; --a) {
                                    var i = this.tryEntries[a],
                                        u = i.completion;
                                    if ("root" === i.tryLoc) return o("end");
                                    if (i.tryLoc <= this.prev) {
                                        var f = n.call(i, "catchLoc"),
                                            c = n.call(i, "finallyLoc");
                                        if (f && c) {
                                            if (this.prev < i.catchLoc) return o(i.catchLoc, !0);
                                            if (this.prev < i.finallyLoc) return o(i.finallyLoc)
                                        } else if (f) {
                                            if (this.prev < i.catchLoc) return o(i.catchLoc, !0)
                                        } else {
                                            if (!c) throw new Error("try statement without catch or finally");
                                            if (this.prev < i.finallyLoc) return o(i.finallyLoc)
                                        }
                                    }
                                }
                            },
                            abrupt: function(t, e) {
                                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                                    var o = this.tryEntries[r];
                                    if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                        var a = o;
                                        break
                                    }
                                }
                                a && ("break" === t || "continue" === t) && a.tryLoc <= e && e <= a.finallyLoc && (a = null);
                                var i = a ? a.completion : {};
                                return i.type = t, i.arg = e, a ? (this.method = "next", this.next = a.finallyLoc, b) : this.complete(i)
                            },
                            complete: function(t, e) {
                                if ("throw" === t.type) throw t.arg;
                                return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), b
                            },
                            finish: function(t) {
                                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                                    var r = this.tryEntries[e];
                                    if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), N(r), b
                                }
                            },
                            catch: function(t) {
                                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                                    var r = this.tryEntries[e];
                                    if (r.tryLoc === t) {
                                        var n = r.completion;
                                        if ("throw" === n.type) {
                                            var o = n.arg;
                                            N(r)
                                        }
                                        return o
                                    }
                                }
                                throw new Error("illegal catch attempt")
                            },
                            delegateYield: function(t, r, n) {
                                return this.delegate = {
                                    iterator: O(t),
                                    resultName: r,
                                    nextLoc: n
                                }, "next" === this.method && (this.arg = e), b
                            }
                        }, t
                    }(t.exports);
                    try {
                        regeneratorRuntime = e
                    } catch (t) {
                        Function("r", "regeneratorRuntime = r")(e)
                    }
                },
                24: t => {
                    t.exports = function(t) {
                        const e = t.toString();
                        return e.startsWith("326") ? "N" : e.startsWith("327") ? "S" : void 0
                    }
                },
                999: (t, e, r) => {
                    const n = r(171),
                        o = r(24);
                    t.exports = function(t) {
                        return `+proj=utm +zone=${n(t)}${"S"===o(t)?" +south ":" "}+ellps=WGS84 +datum=WGS84 +units=m +no_defs`
                    }
                },
                171: t => {
                    t.exports = function(t) {
                        return Number.parseInt(t.toString().substring(3))
                    }
                },
                293: t => {
                    t.exports = function(t) {
                        const e = t.toString();
                        return e.startsWith("326") || e.startsWith("327")
                    }
                },
                870: e => {
                    "use strict";
                    e.exports = t
                }
            },
            r = {};
        function n(t) {
            var o = r[t];
            if (void 0 !== o) return o.exports;
            var a = r[t] = {
                id: t,
                loaded: !1,
                exports: {}
            };
            return e[t].call(a.exports, a, a.exports, n), a.loaded = !0, a.exports
        }
        n.n = t => {
            var e = t && t.__esModule ? () => t.default : () => t;
            return n.d(e, {
                a: e
            }), e
        }, n.d = (t, e) => {
            for (var r in e) n.o(e, r) && !n.o(t, r) && Object.defineProperty(t, r, {
                enumerable: !0,
                get: e[r]
            })
        }, n.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), n.nmd = t => (t.paths = [], t.children || (t.children = []), t);
        var o = {};
        return (() => {
            "use strict";
            n.d(o, {
                default: () => w
            }), n(588);
            var t = n(870),
                e = n(771),
                r = n.n(e),
                a = n(293),
                i = n.n(a),
                u = n(999),
                f = n.n(u);
            function c(t, e, r, n, o, a, i) {
                try {
                    var u = t[a](i),
                        f = u.value
                } catch (t) {
                    return void r(t)
                }
                u.done ? e(f) : Promise.resolve(f).then(n, o)
            }
            function s(t) {
                return function() {
                    var e = this,
                        r = arguments;
                    return new Promise((function(n, o) {
                        var a = t.apply(e, r);
                        function i(t) {
                            c(a, n, o, i, u, "next", t)
                        }
                        function u(t) {
                            c(a, n, o, i, u, "throw", t)
                        }
                        i(void 0)
                    }))
                }
            }
            function l(t, e) {
                return function(t) {
                    if (Array.isArray(t)) return t
                }(t) || function(t, e) {
                    if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
                        var r = [],
                            n = !0,
                            o = !1,
                            a = void 0;
                        try {
                            for (var i, u = t[Symbol.iterator](); !(n = (i = u.next()).done) && (r.push(i.value), !e || r.length !== e); n = !0);
                        } catch (t) {
                            o = !0, a = t
                        } finally {
                            try {
                                n || null == u.return || u.return()
                            } finally {
                                if (o) throw a
                            }
                        }
                        return r
                    }
                }(t, e) || function(t, e) {
                    if (t) {
                        if ("string" == typeof t) return h(t, e);
                        var r = Object.prototype.toString.call(t).slice(8, -1);
                        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? h(t, e) : void 0
                    }
                }(t, e) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                }()
            }
            function h(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
                return n
            }
            function d(t) {
                return (d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                })(t)
            }
            var p = 4326,
                b = new Set([3857, 4269]),
                g = 1e3,
                v = 1e3,
                y = [0, 0],
                m = t.GridLayer.extend({
                    options: {
                        updateWhenIdle: !0,
                        updateWhenZooming: !1,
                        keepBuffer: 25,
                        resolution: Math.pow(2, 5),
                        debugLevel: 0
                    },
                    initialize: function(e) {
                        var n = this;
                        try {
                            if (e.georasters) this.georasters = e.georasters;
                            else {
                                if (!e.georaster) throw new Error("You initialized a GeoRasterLayer without a georaster or georasters value.");
                                this.georasters = [e.georaster]
                            }
                            "url" === this.sourceType && (e.updateWhenIdle = !1, e.updateWhenZooming = !0, e.keepBuffer = 16);
                            var o = ["height", "width", "noDataValue", "palette", "pixelHeight", "pixelWidth", "projection", "sourceType", "xmin", "xmax", "ymin", "ymax"];
                            this.georasters.length > 1 ? o.forEach((function(t) {
                                if (!n.same(n.georasters, t)) throw new Error("all GeoRasters must have the same " + t);
                                n[t] = n.georasters[0][t]
                            })) : 1 === this.georasters.length && o.forEach((function(t) {
                                n[t] = n.georasters[0][t]
                            })), this.ratio = this.height / this.width, this.debugLevel = e.debugLevel, this.debugLevel >= 1 && console.log("georaster:", e), this.georasters.every((function(t) {
                                return "object" === d(t.values)
                            })) && (this.rasters = this.georasters.reduce((function(t, e) {
                                if (e.values) return t.concat(e.values)
                            }), []), this.debugLevel > 1 && console.log("this.rasters:", this.rasters)), this.chroma = r(), this.scale = r().scale(), t.Util.setOptions(this, e);
                            var a = this.getTileSize();
                            if (this.tileHeight = a.y, this.tileWidth = a.x, this.georasters.length > 1 && !e.pixelValuesToColorFn) throw "you must pass in a pixelValuesToColorFn if you are combining rasters";
                            if (1 === this.georasters.length && "url" === this.georasters[0].sourceType && 1 === this.georasters[0].numberOfRasters && !e.pixelValuesToColorFn) throw "pixelValuesToColorFn is a required option for single-band rasters initialized via URL"
                        } catch (t) {
                            console.error("ERROR initializing GeoTIFFLayer", t)
                        }
                    },
                    getRasters: function(e) {
                        var r = this,
                            n = e.tileNwPoint,
                            o = e.heightOfSampleInScreenPixels,
                            a = e.widthOfSampleInScreenPixels,
                            i = e.coords,
                            u = e.numberOfSamplesAcross,
                            f = e.numberOfSamplesDown,
                            c = e.ymax,
                            s = e.xmin;
                        this.debugLevel >= 1 && console.log("starting getRasters with options:", e);
                        var h = function(e, u) {
                                var f = n.x + (u + .5) * a,
                                    h = n.y + (e + .5) * o,
                                    d = t.point(f, h);
                                r.debugLevel >= 1 && console.log("mapPoint:", d);
                                var b = r.getMap().unproject(d, i.z),
                                    g = b.lat,
                                    v = b.lng;
                                if (r.projection === p) return {
                                    y: Math.floor((c - g) / r.pixelHeight),
                                    x: Math.floor((v - s) / r.pixelWidth)
                                };
                                if (r.getProjector()) {
                                    var y = l(r.getProjector().inverse([v, g]), 2),
                                        m = y[0],
                                        w = y[1];
                                    return m !== 1 / 0 && w !== 1 / 0 || r.debugLevel >= 1 && console.error("projector converted", [v, g], "to", [m, w]), {
                                        y: Math.floor((c - w) / r.pixelHeight),
                                        x: Math.floor((m - s) / r.pixelWidth)
                                    }
                                }
                                return null
                            },
                            d = h(0, 0),
                            b = h(f - 1, u - 1),
                            g = {
                                bottom: null == b ? void 0 : b.y,
                                height: f,
                                left: null == d ? void 0 : d.x,
                                right: null == b ? void 0 : b.x,
                                top: null == d ? void 0 : d.y,
                                width: u
                            };
                        if (Object.values(g).every(isFinite)) return Promise.all(this.georasters.map((function(t) {
                            return t.getValues(g)
                        }))).then((function(t) {
                            return t.reduce((function(t, e) {
                                return t.concat(e)
                            }), [])
                        }));
                        console.error("getRasters failed because not all values are finite:", g)
                    },
                    createTile: function(e, r) {
                        var n = t.DomUtil.create("canvas", "leaflet-tile");
                        n.height = this.tileHeight, n.width = this.tileWidth;
                        var o = n.getContext("2d");
                        return this.drawTile({
                            tile: n,
                            coords: e,
                            context: o,
                            done: r
                        })
                    },
                    drawTile: function(e) {
                        var r = this,
                            n = e.tile,
                            o = e.coords,
                            a = e.context,
                            i = e.done,
                            u = this.getMap().options.crs === t.CRS.Simple,
                            f = this.rasters,
                            c = this.xmin,
                            l = this.ymax,
                            h = this.height,
                            b = this.width,
                            g = u ? this.getBounds()._northEast.lat / h : this.pixelHeight,
                            v = u ? this.getBounds()._northEast.lng / b : this.pixelWidth,
                            y = this.xMinOfLayer,
                            m = this.xMaxOfLayer,
                            w = this.yMinOfLayer,
                            x = this.yMaxOfLayer,
                            _ = this._tileCoordsToBounds(o),
                            k = _.getWest(),
                            j = _.getEast(),
                            M = _.getSouth(),
                            L = _.getNorth(),
                            N = 0,
                            S = 0;
                        if (u || this.projection === p) N = Math.ceil((j - k) / v), S = Math.ceil((L - M) / g);
                        else {
                            var O = this.getProjector(),
                                P = O.inverse({
                                    x: k,
                                    y: L
                                }),
                                E = O.inverse({
                                    x: j,
                                    y: L
                                }),
                                T = O.inverse({
                                    x: k,
                                    y: M
                                }),
                                A = O.inverse({
                                    x: j,
                                    y: M
                                });
                            N = Math.ceil(Math.max(E.x - P.x, A.x - T.x) / v), S = Math.ceil(Math.max(P.y - T.y, E.y - A.y) / g)
                        }
                        var R = this.options.resolution,
                            G = Math.min(R, N),
                            B = Math.min(R, S),
                            C = this.tileHeight / B,
                            F = Math.ceil(C),
                            z = this.tileWidth / G,
                            W = Math.ceil(z),
                            V = this.getMap(),
                            I = this.getTileSize(),
                            q = o.scaleBy(I);
                        return setTimeout(s(regeneratorRuntime.mark((function e() {
                            var s, _, k, j;
                            return regeneratorRuntime.wrap((function(e) {
                                for (;;) switch (e.prev = e.next) {
                                    case 0:
                                        if (s = null, f) {
                                            e.next = 5;
                                            break
                                        }
                                        return e.next = 4, r.getRasters({
                                            tileNwPoint: q,
                                            heightOfSampleInScreenPixels: C,
                                            widthOfSampleInScreenPixels: z,
                                            coords: o,
                                            pixelHeight: g,
                                            pixelWidth: v,
                                            numberOfSamplesAcross: G,
                                            numberOfSamplesDown: B,
                                            ymax: l,
                                            xmin: c
                                        });
                                    case 4:
                                        s = e.sent;
                                    case 5:
                                        _ = function(e) {
                                            var n = q.y + (e + .5) * C,
                                                _ = t.point(q.x, n),
                                                k = V.unproject(_, o.z).lat;
                                            if (k > w && k < x) {
                                                var j = function() {
                                                    var w = Math.round(e * C),
                                                        _ = 0;
                                                    (u || r.projection === p) && (_ = Math.floor((x - k) / g));
                                                    for (var j = function(d) {
                                                            var x = t.point(q.x + (d + .5) * z, n),
                                                                j = V.unproject(x, o.z).lng;
                                                            if (j > y && j < m) {
                                                                var M = 0;
                                                                if (u || r.projection === p) M = Math.floor((j - y) / v);
                                                                else if (r.getProjector()) {
                                                                    var L = r.getProjector().inverse({
                                                                            x: j,
                                                                            y: k
                                                                        }),
                                                                        N = L.y;
                                                                    if ((_ = Math.floor((l - N) / g)) < 0 || _ >= h) return "continue";
                                                                    var S = L.x;
                                                                    if ((M = Math.floor((S - c) / v)) < 0 || M >= b) return "continue"
                                                                }
                                                                var O = null;
                                                                if (s) O = s.map((function(t) {
                                                                    return t[e][d]
                                                                }));
                                                                else {
                                                                    if (!f) return i && i(Error("no rasters are available for, so skipping value generation")), {
                                                                        v: {
                                                                            v: {
                                                                                v: void 0
                                                                            }
                                                                        }
                                                                    };
                                                                    O = f.map((function(t) {
                                                                        return t[_][M]
                                                                    }))
                                                                }
                                                                var P = Math.round(d * z),
                                                                    E = w,
                                                                    T = W,
                                                                    A = F;
                                                                if (r.options.customDrawFunction) r.options.customDrawFunction({
                                                                    values: O,
                                                                    context: a,
                                                                    x: P,
                                                                    y: E,
                                                                    width: T,
                                                                    height: A,
                                                                    rasterX: M,
                                                                    rasterY: _,
                                                                    sampleX: d,
                                                                    sampleY: e,
                                                                    sampledRaster: s
                                                                });
                                                                else {
                                                                    var R = r.getColor(O);
                                                                    R && (a.fillStyle = R, a.fillRect(P, E, T, A))
                                                                }
                                                            }
                                                        }, M = 0; M < G; M++) {
                                                        var L = j(M);
                                                        if ("continue" !== L && "object" === d(L)) return L.v
                                                    }
                                                }();
                                                if ("object" === d(j)) return j.v
                                            }
                                        }, k = 0;
                                    case 7:
                                        if (!(k < B)) {
                                            e.next = 14;
                                            break
                                        }
                                        if ("object" !== d(j = _(k))) {
                                            e.next = 11;
                                            break
                                        }
                                        return e.abrupt("return", j.v);
                                    case 11:
                                        k++, e.next = 7;
                                        break;
                                    case 14:
                                        i && i(void 0, n);
                                    case 15:
                                    case "end":
                                        return e.stop()
                                }
                            }), e)
                        }))), 0), n
                    },
                    getBounds: function() {
                        return this.initBounds(), this._bounds
                    },
                    getMap: function() {
                        return this._map || this._mapToAdd
                    },
                    _isValidTile: function(e) {
                        var r = this.getMap().options.crs;
                        if (!r.infinite) {
                            var n = this._globalTileRange;
                            if (!r.wrapLng && (e.x < n.min.x || e.x > n.max.x) || !r.wrapLat && (e.y < n.min.y || e.y > n.max.y)) return !1
                        }
                        var o = this.getBounds();
                        if (!o) return !0;
                        var a = e.x,
                            i = e.y,
                            u = e.z,
                            f = t.latLngBounds(o),
                            c = this._tileCoordsToBounds(e);
                        if (f.overlaps(c)) return !0;
                        if (r === t.CRS.Simple) return !1;
                        var s = Math.pow(2, u),
                            l = t.point(a - s, i);
                        if (l.z = u, f.overlaps(this._tileCoordsToBounds(l))) return !0;
                        var h = t.point(a + s, i);
                        return h.z = u, !!f.overlaps(this._tileCoordsToBounds(h))
                    },
                    getColor: function(t) {
                        var e = this;
                        if (this.options.pixelValuesToColorFn) return this.options.pixelValuesToColorFn(t);
                        var r = t.length;
                        if (t.every((function(t) {
                                return void 0 !== t && t !== e.noDataValue
                            }))) {
                            if (1 == r) {
                                var n = this.georasters[0],
                                    o = n.mins,
                                    a = n.ranges,
                                    i = t[0];
                                if (this.palette) {
                                    var u = l(this.palette[i], 4),
                                        f = u[0],
                                        c = u[1],
                                        s = u[2],
                                        h = u[3];
                                    return "rgba(".concat(f, ",").concat(c, ",").concat(s, ",").concat(h / 255, ")")
                                }
                                return this.scale((t[0] - o[0]) / a[0]).hex()
                            }
                            if (2 === r) return "rgb(".concat(t[0], ",").concat(t[1], ",0)");
                            if (3 === r) return "rgb(".concat(t[0], ",").concat(t[1], ",").concat(t[2], ")");
                            if (4 === r) return "rgba(".concat(t[0], ",").concat(t[1], ",").concat(t[2], ",").concat(t[3] / 255, ")")
                        }
                    },
                    updateColors: function(t) {
                        var e = this,
                            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                                debugLevel: -1
                            },
                            n = r.debugLevel,
                            o = void 0 === n ? -1 : n;
                        if (!t) throw new Error("Missing pixelValuesToColorFn function"); - 1 === o && (o = this.debugLevel), o >= 1 && console.log("Start updating active tile pixel values"), this.options.pixelValuesToColorFn = t;
                        var a = this.getActiveTiles();
                        return a ? (o >= 1 && console.log("Active tiles fetched", a), a.forEach((function(t) {
                            var r = t.coords,
                                n = t.el;
                            e.drawTile({
                                tile: t,
                                coords: r,
                                context: n.getContext("2d")
                            })
                        })), o >= 1 && console.log("Finished updating active tile colours"), this) : (console.error("No active tiles available"), this)
                    },
                    getTiles: function() {
                        return Object.values(this._tiles)
                    },
                    getActiveTiles: function() {
                        var t = this;
                        return this.getTiles().filter((function(e) {
                            return t._isValidTile(e.coords)
                        }))
                    },
                    isSupportedProjection: function(t) {
                        return t || (t = this.projection), i()(t) || b.has(t)
                    },
                    getProjectionString: function(t) {
                        return i()(t) ? f()(t) : "EPSG:".concat(t)
                    },
                    initBounds: function(e) {
                        if (e || (e = this.options), !this._bounds) {
                            var r = this.debugLevel,
                                n = this.height,
                                o = this.width,
                                a = this.projection,
                                i = this.xmin,
                                u = this.xmax,
                                f = this.ymin,
                                c = this.ymax;
                            if (this.getMap().options.crs === t.CRS.Simple) n === o ? this._bounds = t.latLngBounds([y, [g, v]]) : n > o ? this._bounds = t.latLngBounds([y, [g, v / this.ratio]]) : o > n && (this._bounds = t.latLngBounds([y, [g * this.ratio, v]]));
                            else if (a === p) {
                                r >= 1 && console.log("georaster projection is in ".concat(p));
                                var s = t.latLng(f, i),
                                    l = t.latLng(c, u);
                                this._bounds = t.latLngBounds(s, l)
                            } else {
                                if (!this.getProjector()) throw "georaster-layer-for-leaflet does not support rasters with the projection ".concat(a);
                                r >= 1 && console.log("projection is UTM or supported by proj4");
                                var h = this.getProjector().forward({
                                        x: i,
                                        y: f
                                    }),
                                    d = t.latLng(h.y, h.x),
                                    b = this.getProjector().forward({
                                        x: u,
                                        y: c
                                    }),
                                    m = t.latLng(b.y, b.x);
                                this._bounds = t.latLngBounds(d, m)
                            }
                            this.xMinOfLayer = this._bounds.getWest(), this.xMaxOfLayer = this._bounds.getEast(), this.yMaxOfLayer = this._bounds.getNorth(), this.yMinOfLayer = this._bounds.getSouth(), e.bounds = this._bounds
                        }
                    },
                    getProjector: function() {
                        if (this.isSupportedProjection(this.projection)) {
                            if (!proj4) throw "proj4 must be found in the global scope in order to load a raster that uses a UTM projection";
                            return this._projector || (this._projector = proj4(this.getProjectionString(this.projection), "EPSG:".concat(p)), this.debugLevel >= 1 && console.log("projector set")), this._projector
                        }
                    },
                    same: function(t, e) {
                        return 1 === new Set(t.map((function(t) {
                            return t[e]
                        }))).size
                    }
                });
            "object" === ("undefined" == typeof window ? "undefined" : d(window)) && (window.GeoRasterLayer = m), "undefined" != typeof self && (self.GeoRasterLayer = m);
            const w = m
        })(), o.default
    })()
}));
//# sourceMappingURL=georaster-layer-for-leaflet.min.js.maps